import Basescreen from "./components/Basescreen";
import { BrowserRouter as Router, Route, Routes,useHistory } from "react-router-dom";
import Navbar from "./components/Navbar";
import './style/style.scss';
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from 'react-toastify';
import { toast} from 'react-toastify';
function App() {
  const urlString = window.location.href;
  const url = new URL(urlString);
  const token = url.searchParams.get('user_data');

  if(token){

    localStorage.setItem('user_data',token);
  }

  return (
    <>
    <Navbar/>
    <Router>
    <Routes>

        <Route path='/' element={<Basescreen/>} />
       
      </Routes>
    </Router>
    <ToastContainer  className="toastifyclass" />
    </>
  );
}

export default App;
